import { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getDelhiPolls } from "../../redux/actions/pollingAction";
import DynamicTable from "../DynamicTable/DynamicTable";
import moment from "moment";
import { BASE_URL_PP } from "../../redux/api";

const PollBadge = ({ CPC, LPC, NDP, BQ, GPC, PPC }) => {
  return (
    <div className="overflow-x-auto w-[32rem]">
      <table className="min-w-full">
        <tbody className="divide-y divide-transparent">
          <tr className="flex items-baseline">
            <td className="flex-1 py-1 px-2">
              <div className="grid grid-cols-6 gap-2 divide-x divide-transparent">
                <button
                  className="text-xs py-1 px-0 bg-blue-800 text-white shadow-md w-12"
                  type="button"
                >
                  {CPC ?? 0}
                </button>
                <button
                  className="text-xs py-1 px-0 bg-red-600 text-white shadow-md w-12"
                  type="button"
                >
                  {LPC ?? 0}
                </button>
                <button
                  className="text-xs py-1 px-0 bg-orange-600 text-white shadow-md w-12"
                  type="button"
                >
                  {NDP ?? 0}
                </button>
                <button
                  className="text-xs py-1 px-0 bg-cyan-800 text-white shadow-md w-12"
                  type="button"
                >
                  {BQ ?? 0}
                </button>
                <button
                  className="text-xs py-1 px-0 bg-green-600 text-white shadow-md w-12"
                  type="button"
                >
                  {GPC ?? 0}
                </button>
                <button
                  className="text-xs py-1 px-0 bg-purple-700 text-white shadow-md w-12"
                  type="button"
                >
                  {PPC ?? 0}
                </button>
                {/* <button
                  className="text-xs py-1 px-0 bg-[#004c9b] text-white shadow-md w-12"
                  type="button"
                >
                  {CAQ ?? 0}
                </button>
                <button
                  className="text-xs py-1 px-0 bg-[#f96854] text-white shadow-md w-12"
                  type="button"
                >
                  {QS ?? 0}
                </button> */}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

function PollingTable({ ElectionData, type }) {
  const dispatch = useDispatch();
  // const [candidateList, setCandidateList] = useState([]);
  const [candidate, setCandidate] = useState("");
  // const [update, setUpdate] = useState(false);
  const currentDateTime = new Date();
  const dataList = {
    column: [
      {
        title: "DATES",
        field: "createdAt",
        customField: (row) =>
          row?.publish_date
            ? moment(row?.publish_date).format("DD/MM/YYYY")
            : "",
      },
      {
        title: "POLLSTER",
        field: "pollsterName",
        customField: (row) => row.pollster ?? "-",
      },
      {
        title: "POLLSTER ACCURACY",
        field: "accuracies",
        customField: (row, idx) => (
          <>
            {idx === 0 && (
              <div className="text-[12px] grid grid-cols-6 gap-1 text-center ms-0 me-5">
                <p>CPC</p>
                <p>LPC</p>
                <p>NDP</p>
                <p>BQ</p>
                <p>GPC</p>
                <p>PPC</p>
                {/* <p>CAQ</p>
                <p>QS</p> */}
              </div>
            )}
            <PollBadge
              CPC={row?.cpc_Accuracy}
              LPC={row?.lpc_Accuracy}
              NDP={row?.ndp_Accuracy}
              BQ={row?.bq_Accuracy}
              GPC={row?.gpc_Accuracy}
              PPC={row?.ppc_Accuracy}
              // CAQ={row?.CAQAccuracy}
              // QS={row?.QSAccuracy}
            />
          </>
        ),
      },
      {
        title: "SPONSOR",
        field: "publisher",
        customField: (row) => row.publisher ?? "-",
      },
      ...(type === "final_result"
        ? [
            {
              title: "SEATS RESULT",
              field: "seatsResult",
              customField: (row, idx) => (
                <>
                  {idx === 0 && (
                    <div className="text-[12px] grid grid-cols-6 gap-1 ms-0 me-5">
                      <p>CPC</p>
                      <p>LPC</p>
                      <p>NDP</p>
                      <p>BQ</p>
                      <p>GPC</p>
                      <p>PPC</p>
                      {/* <p>CAQ</p>
                      <p>QS</p> */}
                    </div>
                  )}
                  <PollBadge
                    CPC={row?._cpc_seat_result}
                    LPC={row?.lpc_seat_result}
                    NDP={row?.ndp_seat_result}
                    BQ={row?.bq_seat_result}
                    GPC={row?.gpc_seat_result}
                    PPC={row?.ppc_seat_result}
                    // CAQ={row?.coalition_avenir_quebec_result_seats}
                    // QS={row?.quebec_solidaire_party_result_seats}
                  />
                </>
              ),
            },
            {
              title: "VOTESHARE RESULT",
              field: "voteshareResult",
              customField: (row, idx) => (
                <>
                  {idx === 0 && (
                    <div className="text-[12px] grid grid-cols-6 gap-1 ms-0 me-5">
                      <p>CPC</p>
                      <p>LPC</p>
                      <p>NDP</p>
                      <p>BQ</p>
                      <p>GPC</p>
                      <p>PPC</p>
                      {/* <p>CAQ</p>
                      <p>QS</p> */}
                    </div>
                  )}
                  <PollBadge
                    CPC={row?._cpc_voteshare_result}
                    LPC={row?.lpc_voteshare_result}
                    NDP={row?.ndp_voteshare_result}
                    BQ={row?.bq_voteshare_result}
                    GPC={row?.gpc_voteshare_result}
                    PPC={row?.ppc_voteshare_result}
                    // CPC={row?.["CPC_voteshare-result"]}
                    // LPC={row?.["LPC_voteshare-result"]}
                    // NDP={row?.["NDP_voteshare-result"]}
                    // BQ={row?.["BQ_voteshare-result"]}
                    // GPC={row?.["GPC_voteshare-result"]}
                    // PPC={row?.["PPC_voteshare-result"]}
                    // CAQ={row?.coalition_avenir_quebec_result_voteshare}
                    // QS={row?.quebec_solidaire_party_result_voteshare}
                  />
                </>
              ),
            },
          ]
        : [
            {
              title: "SEATS",
              field: "Seats",
              customField: (row, idx) => (
                <>
                  {idx === 0 && (
                    <div className="text-[12px] grid grid-cols-6 gap-1 ms-0 me-5">
                      <p>CPC</p>
                      <p>LPC</p>
                      <p>NDP</p>
                      <p>BQ</p>
                      <p>GPC</p>
                      <p>PPC</p>
                      {/* <p>CAQ</p>
                      <p>QS</p> */}
                    </div>
                  )}
                  <PollBadge
                    CPC={row?._cpc_seats}
                    LPC={row?.lpc_seats}
                    NDP={row?.ndp_seats}
                    BQ={row?.bq_seats}
                    GPC={row?.gpc_seats}
                    PPC={row?.ppc_seats}
                    // CAQ={row?.coalition_avenir_quebec_seats}
                    // QS={row?.quebec_solidaire_party_seats}
                  />
                </>
              ),
            },
            {
              title: "VOTESHARE",
              field: "voteshare",
              customField: (row, idx) => (
                <>
                  {idx === 0 && (
                    <div className="text-[12px] grid grid-cols-6 gap-1 ms-0 me-5">
                      <p>CPC</p>
                      <p>LPC</p>
                      <p>NDP</p>
                      <p>BQ</p>
                      <p>GPC</p>
                      <p>PPC</p>
                      {/* <p>CAQ</p>
                      <p>QS</p> */}
                    </div>
                  )}
                  <PollBadge
                    CPC={row?._cpc_voteshare}
                    LPC={row?.lpc_voteshare}
                    NDP={row?.ndp_voteshare}
                    BQ={row?.bq_voteshare}
                    GPC={row?.gpc_voteshare}
                    PPC={row?.ppc_voteshare}
                    // CAQ={row?.coalition_avenir_quebec_voteshare}
                    // QS={row?.quebec_solidaire_party_voteshare}
                  />
                </>
              ),
            },
          ]),
      // {
      //   title: "SEATS",
      //   field: "Seats",
      //   customField: (row, idx) => (
      //     <>
      //       {idx === 0 && (
      //         <div className="text-[12px] grid grid-cols-6 gap-1 ms-0 me-5">
      //           <p>CPC</p>
      //           <p>LPC</p>
      //           <p>NDP</p>
      //           <p>BQ</p>
      //           <p>GPC</p>
      //           <p>PPC</p>
      //           <p>CAQ</p>
      //           <p>QS</p>
      //         </div>
      //       )}
      //       <PollBadge
      //         CPC={row?.conservative_party_seats}
      //         LPC={row?.liberal_party_seats}
      //         NDP={row?.new_democratic_party_seats}
      //         BQ={row?.bloc_quebecois_seats}
      //         GPC={row?.green_party_seats}
      //         PPC={row?.ppc_seats}
      //         CAQ={row?.coalition_avenir_quebec_seats}
      //         QS={row?.quebec_solidaire_party_seats}
      //       />
      //     </>
      //   ),
      // },
      // {
      //   title: "VOTESHARE",
      //   field: "voteshare",
      //   customField: (row, idx) => (
      //     <>
      //       {idx === 0 && (
      //         <div className="text-[12px] grid grid-cols-6 gap-1 ms-0 me-5">
      //           <p>CPC</p>
      //           <p>LPC</p>
      //           <p>NDP</p>
      //           <p>BQ</p>
      //           <p>GPC</p>
      //           <p>PPC</p>
      //           <p>CAQ</p>
      //           <p>QS</p>
      //         </div>
      //       )}
      //       <PollBadge
      //         CPC={row?.conservative_party_voteshare}
      //         LPC={row?.liberal_party_voteshare}
      //         NDP={row?.new_democratic_party_voteshare}
      //         BQ={row?.bloc_quebecois_voteshare}
      //         GPC={row?.green_party_voteshare}
      //         PPC={row?.ppc_voteshare}
      //         CAQ={row?.coalition_avenir_quebec_voteshare}
      //         QS={row?.quebec_solidaire_party_voteshare}
      //       />
      //     </>
      //   ),
      // },
      // {
      //   title: "SEATS RESULT",
      //   field: "seatsResult",
      //   customField: (row, idx) => (
      //     <>
      //       {idx === 0 && (
      //         <div className="text-[12px] grid grid-cols-8 gap-1 ms-0 me-5">
      //           <p>CPC</p>
      //           <p>LPC</p>
      //           <p>NDP</p>
      //           <p>BQ</p>
      //           <p>GPC</p>
      //           <p>PPC</p>
      //           <p>CAQ</p>
      //           <p>QS</p>
      //         </div>
      //       )}
      //       <PollBadge
      //         CPC={row?.conservative_party_result_seats}
      //         LPC={row?.liberal_party_result_seats}
      //         NDP={row?.new_democratic_party_result_seats}
      //         BQ={row?.bloc_quebecois_result_seats}
      //         GPC={row?.green_party_result_seats}
      //         PPC={row?.ppc_result_seats}
      //         CAQ={row?.coalition_avenir_quebec_result_seats}
      //         QS={row?.quebec_solidaire_party_result_seats}
      //       />
      //     </>
      //   ),
      // },
      // {
      //   title: "VOTESHARE RESULT",
      //   field: "voteshareResult",
      //   customField: (row, idx) => (
      //     <>
      //       {idx === 0 && (
      //         <div className="text-[12px] grid grid-cols-8 gap-1 ms-0 me-5">
      //           <p>CPC</p>
      //           <p>LPC</p>
      //           <p>NDP</p>
      //           <p>BQ</p>
      //           <p>GPC</p>
      //           <p>PPC</p>
      //           <p>CAQ</p>
      //           <p>QS</p>
      //         </div>
      //       )}
      //       <PollBadge
      //         CPC={row?.conservative_party_result_voteshare}
      //         LPC={row?.liberal_party_result_voteshare}
      //         NDP={row?.new_democratic_party_result_voteshare}
      //         BQ={row?.bloc_quebecois_result_voteshare}
      //         GPC={row?.green_party_result_voteshare}
      //         PPC={row?.ppc_result_voteshare}
      //         CAQ={row?.coalition_avenir_quebec_result_voteshare}
      //         QS={row?.quebec_solidaire_party_result_voteshare}
      //       />
      //     </>
      //   ),
      // },
    ],
  };
  const quary = `rows=${200}`;
  useEffect(() => {
    // dispatch(getDelhiPolls());
    if (quary) {
    }
  }, []);

  const handelCandidate = (e) => {
    const candidate = e.target.value;
    setCandidate(candidate);
  };

  return (
    <div className="container mx-auto py-4 border rounded-md border-gray-200 capitalize">
      {/* Search and Dropdown */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4 px-4">
        <div className="flex flex-col mb-4 md:mb-0">
          <div className="text-lg font-semibold pb-1"> Polls</div>
          <div className="text-sm text-gray-500">
            Latest Poll:{" "}
            {`${
              ElectionData?.[0]?.updatedAt
                ? moment(ElectionData?.[0]?.updatedAt).format("llll")
                : ""
            }`}
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-scroll scrollbar-mob">
        <DynamicTable column={dataList?.column} data={ElectionData} />
      </div>
    </div>
  );
}

export default PollingTable;
